/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_School_Switcher_TitleInputs */

const nl_nav_school_switcher_title = /** @type {(inputs: Nav_School_Switcher_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jouw scholen`)
};

/**

* @param {Nav_School_Switcher_TitleInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const nav_school_switcher_title = /** @type {((inputs?: Nav_School_Switcher_TitleInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_School_Switcher_TitleInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_nav_school_switcher_title(inputs)
});
export { nav_school_switcher_title as "nav.school_switcher.title" }